(function($) {
  'use strict';

  var faq = {
    dom: function() {
      this.$showAnswer = $('[data-js-hook="show-answer"]');
    },

    showAnswer: function() {
      this.$showAnswer.click(function(e) {
        e.preventDefault();
        var $this = $(this);
        var $target = $('[data-id="' + $this.data('target') + '"]');
        $target.slideToggle(function() {
          $this.parent('.faq__item').toggleClass('active');
          if ($(this).is(':visible')) {
            $target.parent().find('[data-toggle-type="open"]').css('display', 'none');
            $target.parent().find('[data-toggle-type="close"]').css('display', 'table-cell');
          }
          else {
            $target.parent().find('[data-toggle-type="close"]').css('display', 'none');
            $target.parent().find('[data-toggle-type="open"]').css('display', 'table-cell');
          }
        });
      });
    },

    ready: function() {
      this.dom();
      this.showAnswer();
    }
  };

  $(function() {
    if ($('.faq').length) {
      faq.ready();
    }
  });

})(jQuery);
